import { RootState } from 'store/types';
import { createSelector } from 'reselect';
import { TemporaryTermsAndConditions } from 'store/global/reducers';

export const globalStateSelector = (state: RootState) => state.global;

export const termsAndConditionsSelector = createSelector(
  globalStateSelector,
  state => state.termsAndConditions
);

export const providerSearchTermsSelector = createSelector(
  termsAndConditionsSelector,
  terms => terms?.provider
);

export const tempTermsAndConditionsSelector = createSelector(
  globalStateSelector,
  state => state.temporaryTCAccept || ({} as TemporaryTermsAndConditions)
);

export const initialNavigationCompleteSelector = createSelector(
  globalStateSelector,
  state => state.initialNavigationComplete
);

export const navigationPathAfterAuthenticationSelector = createSelector(
  globalStateSelector,
  global => global.navigationPathAfterAuthentication
);

export const navigationParamAfterAuthenticationSelector = createSelector(
  globalStateSelector,
  global => global.navigationParamAfterAuthentication
);

export const hasFetchedDependencies = createSelector(
  globalStateSelector,
  global => global.hasFetchedDependencies
);

export const isFetchingDependenciesSelector = createSelector(
  globalStateSelector,
  global => global.isFetchingDependencies
);

export const globalIsFetchingSelector = createSelector(
  globalStateSelector,
  global => global.isFetching
);

export const globalErrorSelector = createSelector(globalStateSelector, global => global.error);

export const mhpStatusSelector = createSelector(globalStateSelector, global => global.mhpStatus);
export const mhpStatusIsFetchingSelector = createSelector(
  mhpStatusSelector,
  mhpStatus => mhpStatus.isFetching
);
export const mhpStatusErrorSelector = createSelector(
  mhpStatusSelector,
  mhpStatus => mhpStatus.error
);
export const mhpStatusDataSelector = createSelector(mhpStatusSelector, mhpStatus => mhpStatus.data);

export const loginTypeSelector = createSelector(globalStateSelector, global => global.loginType);
